import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export function useBrowserNativeTransitions() {
  const pathname = usePathname();
  const previousPathname = useRef(pathname);
  const isTransitioning = useRef(false);

  useEffect(() => {
    if (!("startViewTransition" in document)) {
      return;
    }

    const onPopState = () => {
      if (document.hidden || isTransitioning.current) {
        return;
      }

      isTransitioning.current = true;

      const transition = document.startViewTransition(() => {
        // Transition starts immediately, no blocking
      });

      transition.finished
        .then(() => {
          isTransitioning.current = false;
        })
        .catch(() => {
          isTransitioning.current = false;
        });
    };

    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  useEffect(() => {
    previousPathname.current = pathname;
  }, [pathname]);
}
